import { getPublicConfig } from '../config/getPublicConfig';
import { isServerSide } from './isServerSide';

export function getBaseUrl() {
	const { baseUrl } = getPublicConfig();

	if (baseUrl) {
		return baseUrl;
	}

	if (!isServerSide()) {
		return `${window.location.protocol}//${window.location.host}`;
	}

	return undefined;
}
